import { useToast } from "@gearbox-protocol/deploy-tools-ui";
import { useCallback } from "react";

/**
 * Returns a function that copies text to clipboard and shows a toast
 * on success (or a destructive toast on failure).
 */
export function useCopyToast(): (
  text: string,
  description?: string,
) => Promise<void> {
  const { toast } = useToast();

  return useCallback(
    async (text: string, description?: string) => {
      try {
        await navigator.clipboard.writeText(text);
        toast({ variant: "success", title: "Copied", description });
      } catch (e) {
        toast({
          variant: "destructive",
          title: "Failed to copy",
          description: `${e}`,
        });
      }
    },
    [toast],
  );
}
